module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aneck6-11c172b96a14523b32d5bd674dd73ae3.jpg";